module.exports = __webpack_public_path__ + "static/media/0012.c1659b4b.jpg";